import PrivacyPolicyPageContent from '@/components/pages/privacy-policy-page';

export default function PrivacyPolicyPage() {
  return <PrivacyPolicyPageContent />;
}
